import { render, staticRenderFns } from "./LinkageList.vue?vue&type=template&id=1b0d2e9e&scoped=true&"
import script from "./LinkageList.vue?vue&type=script&lang=js&"
export * from "./LinkageList.vue?vue&type=script&lang=js&"
import style0 from "./LinkageList.vue?vue&type=style&index=0&id=1b0d2e9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d2e9e",
  null
  
)

export default component.exports